import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/CommonUtils";
import {EWASTE_API_PATHS, HTTP_METHOD, PROCESS_NAME} from "../constants/EWasteApiPaths";
import {toWasteProfileId} from "../constants/EWasteConfig";

const metricProcessName = "SCC_EWASTE_CONTAINER_CREATE";
const SUB_PROCESS = "createEWasteContainer";

/**
 * Calls OculusService.CreateEWasteContainer via Boson FlowApiGateway.
 *
 * @param {string} wasteProfileId canonical EWC code chosen in the UI (e.g. "20 01 36"). It is
 *   sent to WADM in compact form ("200136") so the derived container display ID is
 *   "200136-xxxx" rather than "20 01 -xxxx"; see {@link toWasteProfileId}.
 */
export async function createEWasteContainer(siteName, wasteProfileId, containerTypeId, maxWeight, locale) {
    const startTime = Date.now();
    const request = {
        resourcePath: EWASTE_API_PATHS.CREATE_CONTAINER,
        httpMethod: HTTP_METHOD.POST,
        processName: PROCESS_NAME.OCULUS,
        requestBody: {
            siteName: siteName,
            wasteProfileId: toWasteProfileId(wasteProfileId),
            containerTypeId: containerTypeId,
            maxWeight: maxWeight,
            locale: locale
        }
    };

    try {
        const response = await getAPIGatewayDataFromParent(request);
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, SUB_PROCESS, true);
            return {
                success: true,
                containerId: response.data && response.data.containerId,
                containerDisplayId: response.data && response.data.containerDisplayId
            };
        }
        logOperationalMetric(startTime, metricProcessName, SUB_PROCESS, false);
        return {success: false};
    } catch (error) {
        logOperationalMetric(startTime, metricProcessName, SUB_PROCESS, false);
        return {success: false};
    }
}



// WEBPACK FOOTER //
// ./src/commons/api/CreateEWasteContainer.js